import { useQuery } from '@tanstack/react-query';
import { useApi } from '@/api/ApiContext';
import type { GetPeriodStatusResponse } from '@/api/handlers/resources/periods/responses';
import type { ApiResponse } from '@/api/handlers/responses';
import { PeriodQueryKeys } from './periodQueryKeys';

const STALE_TIME_MS = 5 * 60_000;

/**
 * Period status for the selected date, driving the Post gate + date warning.
 * Disabled until a date is present. Never rejects (envelope contract) — read
 * `data.success` at the call site.
 */
export const usePeriodStatusQuery = (date: string) => {
    const { apiClient } = useApi();

    return useQuery<ApiResponse<GetPeriodStatusResponse>>({
        queryKey: PeriodQueryKeys.status(date),
        queryFn: () => apiClient.periods.getPeriodStatus(date),
        enabled: date.length > 0,
        staleTime: STALE_TIME_MS,
    });
};
